/* MyLabs single-owner connector 2026-10-06 (+ group validation, tailored thank-you) */
(function () {
  'use strict';

  function connect() {
    var root = document.getElementById('dlr');
    var form = document.getElementById('contact_form');
    if (!root || !form || form.dataset.pipelineConnected === 'true') return;
    form.dataset.pipelineConnected = 'true';
    form.dataset.pipelineVersion = '20261006-single-owner';
    form.dataset.partialAccepted = 'false';
    form.dataset.intakeAccepted = 'false';

    var query = new URLSearchParams(window.location.search);
    if (query.get('contact_posted') === 'true') {
      var labsFlag = query.get('labs');
      if (labsFlag === 'has' || labsFlag === 'need') root.setAttribute('data-labs', labsFlag);
      root.setAttribute('data-submitted', 'true');
      return;
    }

    var base = 'https://alluring-respect-production-47c7.up.railway.app/inventory/growth/leads/';
    var busy = false;
    var completed = false;
    var debounce;
    var partialBusy = false;
    var queuedPartial = null;
    var lastPartial = '';
    var startedAt = new Date().toISOString();
    var nativeMethod = form.method;
    var button = form.querySelector('button[type="submit"]');
    var buttonText = button ? button.textContent : '';
    var status = document.createElement('p');
    status.className = 'err';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.hidden = true;
    form.appendChild(status);

    function field(name) { return form.elements.namedItem('contact[' + name + ']'); }
    function text(name, limit) {
      var input = field(name);
      var value = input ? input.value.trim() : '';
      return limit ? value.slice(0, limit) : value;
    }
    function setHidden(id, value) {
      var input = document.getElementById(id);
      if (input) input.value = value;
    }
    function uuid() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      var bytes = new Uint8Array(16);
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') window.crypto.getRandomValues(bytes);
      else for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      var hex = Array.prototype.map.call(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
    }
    var submissionId = uuid();
    var source = (query.get('src') || query.get('utm_source') || 'website').trim().toLowerCase().split(' / ', 1)[0];
    if (!/^[a-z0-9][a-z0-9_-]{0,159}$/.test(source)) source = 'website';
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) {
      var value = query.get(key);
      if (value) utm[key] = value.replace(/[\x00-\x1f\x7f]/g, '').trim().slice(0, 200);
    });
    setHidden('dlrSubmission', submissionId);
    setHidden('dlrSubmittedAt', startedAt);
    setHidden('dlrUtm', JSON.stringify(utm));
    setHidden('dlrSrc', source);
    var returnParams = new URLSearchParams(query);
    returnParams.set('contact_posted', 'true');
    setHidden('dlrReturn', '/pages/mylabs?' + returnParams.toString() + '#contact_form');

    // Keep the existing anonymous visit count; contact and answers are excluded.
    try {
      var visitKey = 'diata-mylabs-visit:' + source;
      var visitId = window.sessionStorage.getItem(visitKey);
      if (!visitId && typeof window.fetch === 'function') {
        visitId = uuid();
        window.sessionStorage.setItem(visitKey, visitId);
        window.fetch(base + 'visit', {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
          headers: { 'Content-Type': 'application/json' }, keepalive: true,
          body: JSON.stringify({ source: source, utm: utm, visit_id: visitId })
        }).catch(function () {});
      }
    } catch (_) {}

    function validEmail(value) { return value.length <= 254 && /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(value); }
    function validPhone(value) {
      var digits = value.replace(/\D/g, '');
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return value.length <= 40 && digits.length >= 7 && digits.length <= 15;
    }
    function selected(name) {
      var inputs = form.querySelectorAll('input[name="contact[' + name + ']"]');
      for (var i = 0; i < inputs.length; i++) if (inputs[i].checked) return inputs[i].value;
      return 'Unknown';
    }
    function payload(partial) {
      var email = text('email').toLowerCase();
      var phone = text('phone');
      if (partial) {
        if (!validEmail(email)) email = '';
        if (!validPhone(phone)) phone = '';
        if (!email && !phone) return null;
      }
      var goals = [];
      var goalInputs = form.querySelectorAll('input[type="checkbox"]');
      for (var i = 0; i < goalInputs.length; i++) {
        var match = /^contact\[Goal: (.+)\]$/.exec(goalInputs[i].name);
        if (match && goalInputs[i].checked && match[1] !== 'Other') goals.push(match[1]);
      }
      var other = document.getElementById('g-other');
      return {
        submission_id: submissionId,
        partial: partial,
        first_name: text('first_name', partial ? 80 : 0),
        last_name: text('last_name', partial ? 80 : 0),
        email: email,
        phone: phone,
        goals: goals,
        goals_other: other && other.checked ? text('Goal: Other (details)', partial ? 500 : 0) : '',
        glp1_answer: selected('On a GLP-1'),
        labs_answer: selected('Labs in the last year'),
        notes: text('body', partial ? 4000 : 0),
        source: source,
        utm: utm,
        submitted_at: partial ? startedAt : new Date().toISOString()
      };
    }
    function testName(data) { return /\bTEST\d*\b/i.test(data.first_name + ' ' + data.last_name); }
    function post(path, data, keepalive) {
      if (typeof window.fetch !== 'function') return Promise.reject(new Error('unavailable'));
      var controller = typeof window.AbortController === 'function' ? new AbortController() : null;
      var timer;
      var request = window.fetch(base + path, {
        method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data),
        signal: controller ? controller.signal : undefined, keepalive: Boolean(keepalive)
      }).then(function (response) {
        if (response.status !== 202) throw new Error('not accepted');
        return response.json();
      }).then(function (result) {
        if (!result || result.accepted !== true || result.submission_id !== data.submission_id) throw new Error('not accepted');
      });
      var timeout = new Promise(function (_, reject) {
        timer = window.setTimeout(function () {
          if (controller) controller.abort();
          reject(new Error('timeout'));
        }, 8000);
      });
      return Promise.race([request, timeout]).then(function () {
        window.clearTimeout(timer);
      }, function (error) {
        window.clearTimeout(timer);
        throw error;
      });
    }
    function drainPartial() {
      if (busy || completed || partialBusy || !queuedPartial) return;
      var next = queuedPartial;
      queuedPartial = null;
      if (next.signature === lastPartial) return;
      partialBusy = true;
      post('partial', next.data, next.keepalive).then(function () {
        lastPartial = next.signature;
        form.dataset.partialAccepted = 'true';
      }).catch(function () {
        // Final intake and the independent Shopify backup remain available.
      }).then(function () {
        partialBusy = false;
        drainPartial();
      });
    }
    function queuePartial(keepalive) {
      if (busy || completed) return;
      var data = payload(true);
      if (!data) { queuedPartial = null; return; }
      queuedPartial = { data: data, signature: JSON.stringify(data), keepalive: keepalive };
      drainPartial();
    }
    function updateValidation() {
      // A TEST form cannot use even a programmatic native submit as transport.
      form.method = testName({ first_name: text('first_name'), last_name: text('last_name') }) ? 'dialog' : nativeMethod;
      Object.keys(limits).forEach(function (name) {
        var input = field(name);
        if (input) input.setCustomValidity('');
      });
      var other = document.getElementById('g-other');
      var details = field('Goal: Other (details)');
      if (details) {
        details.required = Boolean(other && other.checked);
        details.setCustomValidity(details.required && !details.value.trim() ? 'Please tell us a little more about your goal.' : '');
      }
      var phone = field('phone');
      if (phone) phone.setCustomValidity(phone.value && !validPhone(phone.value.trim()) ? 'Please enter a valid phone number.' : '');
      var email = field('email');
      if (email) email.setCustomValidity(email.value && !validEmail(email.value.trim()) ? 'Please enter a valid email address.' : '');
      ['first_name', 'last_name'].forEach(function (name) {
        var input = field(name);
        if (input) input.setCustomValidity(input.value && !input.value.trim() ? 'Please enter your ' + name.replace('_', ' ') + '.' : '');
      });
      Object.keys(limits).forEach(function (name) {
        var input = field(name);
        if (input && input.value.trim().length > limits[name]) input.setCustomValidity('Please use ' + limits[name] + ' characters or fewer.');
      });
    }
    var limits = { first_name: 80, last_name: 80, email: 254, phone: 40, 'Goal: Other (details)': 500, body: 4000 };
    Object.keys(limits).forEach(function (name) {
      var input = field(name);
      if (input) input.maxLength = limits[name];
    });
    function schedulePartial() {
      updateValidation();
      window.clearTimeout(debounce);
      debounce = window.setTimeout(function () { queuePartial(false); }, 550);
    }
    form.querySelectorAll('input[type="radio"][required]').forEach(function (r) { r.required = false; });
    form.addEventListener('input', schedulePartial);
    form.addEventListener('change', schedulePartial);
    window.addEventListener('pagehide', function () {
      window.clearTimeout(debounce);
      queuePartial(true);
    });
    updateValidation();

    var groupErrs = [];
    function clearGroupErrs() {
      groupErrs.forEach(function (q) { q.classList.remove('bad', 'bad-other'); var e = q.querySelector('.err'); if (e) e.remove(); });
      groupErrs = [];
    }
    function groupErr(sel, msg, cls) {
      var el = form.querySelector(sel); var q = el ? el.closest('.q') : null; if (!q) return;
      var e = q.querySelector('.err');
      if (!e) { e = document.createElement('p'); e.className = 'err'; e.setAttribute('role', 'alert'); q.appendChild(e); }
      e.textContent = msg; q.classList.add(cls || 'bad'); if (groupErrs.indexOf(q) < 0) groupErrs.push(q);
    }
    function checkGroups() {
      clearGroupErrs();
      if (!form.querySelector('input[name^="contact[Goal: "][type="checkbox"]:checked')) groupErr('#g1', 'Please choose at least one.');
      var oth = document.getElementById('g-other'), det = field('Goal: Other (details)');
      if (oth && oth.checked && det && !det.value.trim()) groupErr('#g1', 'Please tell us a little more about \u201cOther.\u201d', 'bad-other');
      if (!form.querySelector('input[name="contact[On a GLP-1]"]:checked')) groupErr('#glp-y', 'Please choose one.');
      if (!form.querySelector('input[name="contact[Labs in the last year]"]:checked')) groupErr('#lab-y', 'Please choose one.');
      return groupErrs.length === 0;
    }
    form.addEventListener('change', function () { if (groupErrs.length) checkGroups(); });
    function retryMessage() {
      busy = false;
      form.inert = false;
      form.removeAttribute('aria-busy');
      if (button) { button.disabled = false; button.textContent = buttonText; }
      status.textContent = 'We could not submit this request. Please try again.';
      status.hidden = false;
    }
    function nativeBackup() {
      // Genuine requests keep the independent hello@ Shopify contact backup.
      // TEST requests never call this path.
      if (testName(payload(false))) { retryMessage(); return; }
      try {
        // Shopify replaces form.submit with its hCaptcha-aware wrapper.
        form.submit();
        completed = true;
      } catch (_) { retryMessage(); }
    }
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      // Shopify's form and document handlers can submit despite preventDefault.
      // Owning capture prevents them from running before our API/TEST decision.
      event.stopImmediatePropagation();
      if (busy || completed) return;
      updateValidation();
      var textOk = true;
      ['first_name', 'last_name', 'email', 'phone'].forEach(function (n) { var i = field(n); if (i && !i.checkValidity()) textOk = false; });
      var groupsOk = checkGroups();
      if (!textOk) { form.reportValidity(); return; }
      if (!groupsOk) { groupErrs[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      if (!form.reportValidity()) return;
      var data = payload(false);
      var labsFlag = /^Yes/.test(data.labs_answer) ? 'has' : 'need';
      var rp = new URLSearchParams(query); rp.set('contact_posted', 'true'); rp.set('labs', labsFlag);
      setHidden('dlrReturn', '/pages/mylabs?' + rp.toString() + '#contact_form');
      root.setAttribute('data-labs', labsFlag);
      busy = true;
      form.inert = true;
      form.setAttribute('aria-busy', 'true');
      window.clearTimeout(debounce);
      queuedPartial = null;
      status.hidden = true;
      setHidden('dlrSubmittedAt', data.submitted_at);
      if (button) { button.disabled = true; button.textContent = 'Submitting…'; }
      post('intake', data, false).then(function () {
        form.dataset.intakeAccepted = 'true';
        if (testName(data)) {
          completed = true;
          root.setAttribute('data-submitted', 'true');
        } else nativeBackup();
      }).catch(function () {
        if (testName(data)) retryMessage();
        else nativeBackup();
      });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
})();
